import { useContext, useMemo } from "react";
import { ContextEDH } from "@context/ContextEDH";

export const useProgrammingStructuresPermissions = () => {
  const { state } = useContext(ContextEDH);

  const permissions = useMemo(() => {
    return (
      state?.base?.base?.productConfigurations?.find(
        (config: any) => config.id === "programming_structures",
      )?.permissions ?? {
        read: false,
        update: false,
        create: false,
        delete: false,
      }
    );
  }, [state?.base?.base?.productConfigurations]);

  return {
    permissions,
  };
};
